import { ref } from "@vue/composition-api";

const snackBar = ref(false);
const snackBarMessage = ref("Mise à jour avec succès");

export function showSnackBar() {
  snackBar.value = true;
}

export function hideSnackBar() {
  snackBar.value = false;
}
export function useSnackBar() {
  return {
    snackBar,
    snackBarMessage,
  };
}
